import React, { useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { ICON_NAMES } from '../../../../constants'
import SydButton from '../../../commonDesign/Button'
import Icon from '../../../atoms/Icon'
import { nodeTypeListMap } from '../NodeLinkComponents/constants'
import SydSelect from '../../../commonDesign/SydSelect'

const useStyles = makeStyles({
  toggleButton: {
    position: 'absolute',
    top: 6,
    left: 6,
    zIndex: 101,
    transform: 'translate(0, 0)',
    transition: 'transform 0.3s ease-in-out',
    '&.open': {
      transform: 'translate(415px, 0)'
    }
  },
  innerContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '500px',
    background: 'color-mix(in srgb, var(--theme-color-surface-d0) 70%, transparent)',
    borderRight: 'var(--border-primary-thin)',
    padding: 'var(--padding-md)',
    boxShadow: 'var(--shadow-md)',
    backdropFilter: 'blur(10px)',
    zIndex: 100,
    transform: 'translate(-100%, 0)',
    transition: 'transform 0.3s ease-in-out',
    overflowY: 'scroll',
    '&.open': {
      transform: 'translate(0, 0)'
    }
  }
})

export const AddNodeSidebar = () => {
  const classes = useStyles()
  const [selectedNodeType, setSelectedNodeType] = useState(null)

  const { state, dispatch } = useEntityGraphContext()
  const { displayAddNode } = useMemo(() => state ?? {}, [state])
  const { nodeCreation } = useMemo(() => state?.config ?? {}, [state])

  const SelectedNodeTypeComponent = useMemo(() => {
    if (!selectedNodeType) return null
    return nodeTypeListMap[selectedNodeType]?.component || null
  }, [selectedNodeType])

  if (!nodeCreation?.enabled) {
    return null
  }

  return (
    <div className={classes.container}>
      <SydButton
        className={clsx(classes.toggleButton, { open: displayAddNode })}
        onClick={() => dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'displayAddNode', value: !displayAddNode } })}
      >
        <Icon name={displayAddNode ? ICON_NAMES.close : ICON_NAMES.accountTreeRounded} size='md' />
      </SydButton>
      <div className={clsx(classes.innerContainer, { open: displayAddNode })}>
        <div className='flex flex-col gap-2'>
          <h2 className='text-lg font-bold m-0'>Add New Item</h2>
          {displayAddNode && nodeCreation.levels.length > 0 ? (
            <div className='flex flex-col gap-2'>
              <SydSelect
                label='Select Node Type'
                size='sm'
                options={nodeCreation.levels.map(level => ({
                  label: nodeTypeListMap[level]?.label || level,
                  value: level
                }))}
                placeholder='Select a node type'
                onChange={(e) => setSelectedNodeType(e.target.value)}
                value={selectedNodeType}
              />
              {SelectedNodeTypeComponent && (
                <SelectedNodeTypeComponent
                  onAdd={(node) => dispatch({ type: 'ADD_NODE', payload: node })}
                />
              )}
            </div>
          ) : (
            <p className='text-sm text-gray-500'>No node types available for creation.</p>
          )}
        </div>
      </div>
    </div>
  )
}
